module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selected-sold-property-cluster-pin-7dcf159da00db0aa80e3a185983a9448.svg";